import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreDetailsRoutingModule } from './store-details-routing.module';
import { NavbarModule } from '../navbar/navbar.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingModule } from '../loading/loading.module';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';

import { StoreDetailsComponent } from './store-details/store-details.component';
import { StoreDetailsNavbarComponent } from './store-details-navbar/store-details-navbar.component';
import { StoreDetailsHeaderComponent } from './store-details-header/store-details-header.component';
import { StoreDetailsGeneralComponent } from './store-details-general/store-details-general.component';
import { StoreDetailsGeneralInfoComponent } from './store-details-general-info/store-details-general-info.component';
import { StoreDetailsGeneralOwnershipComponent } from './store-details-general-ownership/store-details-general-ownership.component';
import { StoreDetailsGeneralPluginComponent } from './store-details-general-plugin/store-details-general-plugin.component';
import { StoreDetailsGeneralSettingsComponent } from './store-details-general-settings/store-details-general-settings.component';
import { StoreDetailsTeamDataComponent } from './store-details-team-data/store-details-team-data.component';
import { StoreDetailsTeamDataTableComponent } from './store-details-team-data-table/store-details-team-data-table.component';
import { StoreDetailsEventDataComponent } from './store-details-event-data/store-details-event-data.component';
import { StoreDetailsPendingInvitationsDataComponent } from './store-details-pending-invitations-data/store-details-pending-invitations-data.component';
import { StoreDetailsPendingInvitationsDataTableComponent } from './store-details-pending-invitations-data-table/store-details-pending-invitations-data-table.component';
import { StoreDetailsOrderDataComponent } from './store-details-order-data/store-details-order-data.component';
import { StoreDetailsOrderDataTableComponent } from './store-details-order-data-table/store-details-order-data-table.component';

@NgModule({
  declarations: [
    StoreDetailsComponent,
    StoreDetailsNavbarComponent,
    StoreDetailsHeaderComponent,
    StoreDetailsGeneralComponent,
    StoreDetailsGeneralInfoComponent,
    StoreDetailsGeneralOwnershipComponent,
    StoreDetailsGeneralPluginComponent,
    StoreDetailsGeneralSettingsComponent,
    StoreDetailsTeamDataComponent,
    StoreDetailsTeamDataTableComponent,
    StoreDetailsEventDataComponent,
    StoreDetailsPendingInvitationsDataComponent,
    StoreDetailsPendingInvitationsDataTableComponent,
    StoreDetailsOrderDataComponent,
    StoreDetailsOrderDataTableComponent,
  ],
  imports: [
    CommonModule,
    StoreDetailsRoutingModule,
    NavbarModule,
    ToolbarModule,
    TranslateModule,
    LoadingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatTableModule,
  ],
})
export class StoreDetailsModule {}
